import { reloadApp, getOrigin, getPathname } from "../../lib/platform";

// App update available banner
function UpdateBanner({version}) {
  if (!version) return null;
  return (
    <div style={{background:"linear-gradient(135deg,#1d4ed8,#4f46e5)",padding:"10px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",gap:8}}>
      <div style={{display:"flex",alignItems:"center",gap:8}}>
        <span style={{fontSize:14}}>⬆️</span>
        <div>
          <div style={{fontSize:12,fontWeight:700,color:"#fff"}}>Update available — v{version}</div>
          <div style={{fontSize:10,color:"#a5b4fc"}}>Refresh to get the latest version</div>
        </div>
      </div>
      <button
        onClick={()=>{ reloadApp(getOrigin() + getPathname() + '?_v=' + Date.now()); }}
        style={{background:"#fff",border:"none",borderRadius:8,padding:"6px 12px",color:"#1d4ed8",fontSize:11,fontWeight:800,cursor:"pointer",fontFamily:"inherit",whiteSpace:"nowrap"}}>
        Refresh
      </button>
    </div>
  );
}

export default UpdateBanner;
